import styled from "styled-components";

export const ChatActionsContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 10px;

`
export const ActionButton = styled.button`
&& {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  margin: 0;
  border: 1px solid ${(props) => props?.theme?.themeConfig?.chatFooter?.actionButtons?.color ?? props?.theme?.themeConfig?.primaryColor};
  width: 38px;
  height: 38px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background: ${(props) => props?.theme?.themeConfig?.chatFooter.actionButtons?.backgroundColor || 'white'};

  svg {
    width: 24px;
    height: 24px;
    fill: transparent;

    path, rect, circle, line {
      stroke: ${(props) => props?.theme?.themeConfig?.chatFooter?.actionButtons?.color ?? props?.theme?.themeConfig?.primaryColor};
    }
  }

  &:not(:disabled):hover {
    background-color: ${(props) => props?.theme?.themeConfig?.chatFooter?.actionButtons?.color ?? props?.theme?.themeConfig?.primaryColor};

    svg {
      path, rect, circle, line {
        stroke: ${(props) => props?.theme?.themeConfig?.chatFooter?.actionButtons?.backgroundColor || 'white'};

      }
    }
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;

    svg {
      path,
      rect,
      circle,
      line {
        stroke: ${(props) =>
          props?.theme?.themeConfig?.chatFooter?.actionButtons?.color ??
          props?.theme?.themeConfig?.primaryColor};
        opacity: 0.7;
      }
    }
  }
}

`
